import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { city } from 'src/app/shared/classes/city';
import { MasterService } from 'src/app/shared/services/master.service';
import {DataContextService} from '../../../shared/services/data-context.service';
// import {ToastrComponent} from 'src/app/shared/components/toastr-component/toastr-component.component';
import {OfficesTableComponent} from 'src/app/pages/offices/offices-table/offices-table.component';
import { ConstantsService } from '../../../shared/services/Constants/constants.service';
import {ToastrService} from 'ngx-toastr';
import { OfficesService } from 'src/app/shared/services/offices.service';
import { takeUntil } from 'rxjs/operators';
import {Subject} from 'rxjs';
import { Country } from '../../../shared/classes/Country';
import { AuditData, AuditTrail } from '../../../shared/classes/AuditTrail';
import { OfficeView } from '../../../shared/classes/officeView';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';


@Component({
  selector: 'app-edit-office',
  templateUrl: './edit-office.component.html',
  styleUrls: ['../add-office/add-office.component.less']
})
export class EditOfficeComponent implements OnInit, OnDestroy {

  public cityData: city[] = [];
  public CountryData: Country[] = [];
  CountrySelected:number;
  selectedCountry:string;
  CitySelected: number;
  cityName : string;
  countryName : string;
  MasterList: any;
  selectedOffice : any;
  OfficeId : number;
  OfficeAddress:string;
  selectedCityId : any;
  OfficeName: string;
  CountryName: string;
  CityName: string;
  Status:any;
  officeView:OfficeView;
  oldAuditData: any = [];
  selectActiveStatus: {isChecked: boolean} = {isChecked : false};
  selectInActiveStatus: {isChecked: boolean} = {isChecked : false};
  oldValues: any = [];
  newValues: any = [];
  auditResult: AuditTrail = new AuditTrail();

  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  constructor(
    private _dataContextService : DataContextService,
    private _masterService: MasterService,
    public modalRef:BsModalRef,
    private toast : ToastrService,
    private officeService: OfficesService,
    private http: HttpClient,
    private trackeromnitureservice:TrackerOmnitureService )
    { 
      this.service_URL = ConstantsService; 
    }

  ngOnInit() {
    this.getData();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('office-edit',username);
    this.trackeromnitureservice.trackPage("pageView");
    //Set Old Values from here
    this.oldAuditData = this.selectedOffice;

    this.OfficeId = this.selectedOffice.officeID;
    
    // console.log(this.OfficeId)
    // this.CityId= this.selectedCityId;

    // setTimeout(() => {
    //   //Add Countries to CountryData List
    //   for(var i=0;i<this.MasterList.length;i++){
    //     var _cd = new Country();
    //     _cd.countryId = this.MasterList[i].countryID;
    //     _cd.countryName = this.MasterList[i].countryName;

    //     this.CountryData.push(_cd);
    //   }
      
    //   console.log(this.CountryData);

    //   //Add Cities to CityData List
    //   for(var i=0;i<this.MasterList.length;i++){
    //     this.MasterList[i].cityList.forEach(element => {
    //       var _cy = new city();
    //       _cy.cityId = element.cityID;
    //       _cy.cityName = element.cityName;
    //       _cy.countryId = element.countryID;

    //       this.cityData.push(_cy);
    //     })
    //   }

    //   console.log(this.cityData);

    //   this.CountrySelected=this.cityData.find(x=>x.cityId==this.selectedOffice.cityID).countryId;

    //   this.CitySelected= this.selectedOffice.cityID;
    //   this.OfficeName = this.selectedOffice.officeName;
    //   this.cityName = this.selectedOffice.cityName;
    //   this.countryName = this.selectedOffice.countryName;

    //   if(this.selectedOffice.isActive){
    //       this.selectActiveStatus.isChecked=true;
    //   }
    //   else{
    //     this.selectInActiveStatus.isChecked=true;
    //   }
    // }, 1000);

    this.OfficeName = this.selectedOffice.officeName;
    this.CountryName = this.selectedOffice.countryName;
    this.CityName = this.selectedOffice.cityName;
    this.OfficeAddress=this.selectedOffice.officeAddress;
this.CitySelected= this.selectedOffice.cityID;

    if(this.selectedOffice.isActive){
        this.selectActiveStatus.isChecked=true;
    }
    else{
      this.selectInActiveStatus.isChecked=true;
    }
  }

  showBtn(){
    if(this.OfficeName !== '' || this.OfficeName.length != 0){
      return false;
    }
    return true;
  }

  setOldValues(oldOfficeData:any){
    this.oldValues.isActive = oldOfficeData.isActive == true ? "true" : "false";
    this.oldValues.officeName = oldOfficeData.officeName;
    this.oldValues.officeAddress=oldOfficeData.officeAddress
    this.oldValues = Object.keys(this.oldValues).map(key => ({Name: key, Value: this.oldValues[key]}));
  }

  setNewValues(newAuditValues: any){
    this.newValues.isActive = this.Status == true ? "true": "false";
    this.newValues.officeName = newAuditValues.officeName;
    this.newValues.officeAddress=newAuditValues.OfficeAddress;
    this.newValues = Object.keys(this.newValues).map(key => ({Name: key, Value: this.newValues[key]}));
  }

  convertToIST(date: any){
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    var isodate = date.toISOString();

    return isodate;
  }

  saveToAuditTrail(oldAuditData,newAuditValues,changedBy: string){
    this.setOldValues(oldAuditData);
    this.setNewValues(newAuditValues);

    let auditData: AuditTrail = new AuditTrail();
    auditData.changedBy = changedBy;
    //Use Enums
    auditData.actionPerformed = "Update";
    auditData.actionPerformedOn = "Office";
    auditData.primaryKey = this.selectedOffice.officeName;
    auditData.dateChanged = this.convertToIST(new Date());
    
    let auditText: Array<AuditData> = new Array<AuditData>();

    this.oldValues.forEach(oldValues => {
      this.newValues.forEach(newValues => {
        if(oldValues.Name == newValues.Name){
          if(oldValues.Value != newValues.Value){
            var obj : AuditData = new AuditData();
            obj.changedAttribute = oldValues.Name;
            obj.oldValue = oldValues.Value;
            obj.newValue = newValues.Value;
            auditText.push(obj);
          }
        }
      })
    })

    auditData.messageText = auditText;
    this.auditResult = auditData;
  }

  EditOffice(office)
  {
    var data = office;
    // console.log(data);
    // this._masterService.getMastersData()
    // .pipe(takeUntil(this.unsubscribe$))
    // .subscribe((data) => {
    //   this.MasterList = data;
    //   this.cityData = this.MasterList.city;
    // })
    if(this.selectActiveStatus.isChecked){
      this.Status=true;
    }
    else{
      this.Status=false;
    }
   
    var username = localStorage.getItem('email');


   let params = {
     officeID : this.selectedOffice.officeID,
     OfficeAddress:this.OfficeAddress,
     officeName : office,
     cityID :this.CitySelected,
     cityName : this.CityName,
     countryName : this.CountryName,
     changedBy: username,
     addedBy: this.selectedOffice.addedBy,
     dateAdded: this.selectedOffice.dateAdded,
     isActive:this.Status,
     ccMail: username
    };
 // this.saveToAuditTrail(office,username);
 this.saveToAuditTrail(this.oldAuditData,params,username);
   this._dataContextService.postDatawithValues<any>(this.service_URL.OfficeDetails.EditOffice,params)
   .pipe(takeUntil(this.unsubscribe$))
   .subscribe(res => {      
     
        if(res == 1)
        {    
          this.toast.success("Successfully updated office details!");
          
        } 
        else if(res == 0)
        {
          this.toast.error("Some thing went on wrong..");
        }
        else if (res == 2) {
          this.toast.error("Floor and Gate details are already exist in this office");
        }
       
        //ToastrComponent.success("Successfully updated office details!");
   },
   (err)=>{
    console.log(err);
   },
   () => {
    //Saving Data in Audit Trail
    let auditParams = {
      actionPerformed : this.auditResult.actionPerformed,
      actionPerformedOn : this.auditResult.actionPerformedOn,
      changedBy : this.auditResult.changedBy,
      dateChanged : this.auditResult.dateChanged,
      primaryKey : this.auditResult.primaryKey,
      messageText : this.auditResult.messageText
    };

    /*this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      // console.log(res);
    })*/
    let tokenNew = localStorage.getItem('accessToken');
    var headers=new HttpHeaders({ 
      'Authorization' : `Bearer ${tokenNew}`
    })
    this.http.post<any>(this.service_URL.AuditTrail.saveconfigaudittrail, auditParams,{headers:headers})
      .subscribe(res => { 
        console.log(res);
      },
      (err)=>{
        console.log(err);
      },
      ()=>{
        this.officeService.refreshwithFilters.next();
        this.modalRef.hide();
      }
      );
   })
    
  }

  getData(){
    //OfficeMasterData API/
    this._masterService.getOfficeMasterData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.MasterList = data;
    })
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
